// @flow
import React from 'react';
import Flex from '@waglabs/flex';
import Text from '@waglabs/text';
import Image from '@waglabs/image';

import { icons } from './icons';

export type ResponsiveIconAndTextBlockProps = {
  headingText?: string,
  headingTextColor?: string,
  icon: string,
  text: string,
}

type Props = ResponsiveIconAndTextBlockProps;

export const ResponsiveIconAndTextBlock = ({
  headingText,
  headingTextColor,
  icon,
  text,
}: Props) => (
  <Flex
    flexDirection={['row', 'column']}
    justifyContent={['flex-start', 'center']}
    alignItems={['center']}
    boxSizing="border-box"
    px={3}
    width={1}
    mb={3}
  >
    <Image
      src={icons[icon]}
      width="56px"
      mb={[0, 3]}
    />

    <Flex
      flexDirection={['column']}
      ml={[3, 0]}
    >
      {headingText && (
        <Text
          m={0}
          mb={2}
          color={headingTextColor}
          fontFamily="body"
          fontWeight={5}
          fontSize={[3, 4, 5, 6]}
          textAlign={['left', 'center']}
        >
          {headingText}
        </Text>
      )}

      <Text
        m={0}
        fontFamily="body"
        fontSize={[3, 4, 4]}
        maxWidth={['100%', '100%', 400, 500]}
        color="medGray"
        textAlign={['left', 'center']}
        width={[1]}
      >
        {text}
      </Text>
    </Flex>
  </Flex>
);

ResponsiveIconAndTextBlock.defaultProps = {
  headingTextColor: 'medGray',
};
